import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface ChargeStatusFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const chargeStatuses = [
  { id: 'succeeded', name: 'Succeeded' },
  { id: 'failed', name: 'Failed' },
  { id: 'pending', name: 'Pending' },
];

export const ChargeStatusFilter: React.FC<ChargeStatusFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map(
            (v) => chargeStatuses.find((option) => option.id === v)?.name || ''
          )
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) =>
      chargeStatuses.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={chargeStatuses}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? chargeStatuses.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder="Select Charge Status"
        />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
